<template>
    <div class="footercomponent">
        <div class="page-footer bg-secondary-light d-flex flex-column justify-content-between px-6 pt-4 pb-0" style="padding-bottom: 30px !important;" :class="{'zindextoggle':triggerZinde == true, 'changingzindex':triggerZindexes == true}">
            <div class="helpdesk-footer d-md-block hidden-sm-down" @click="openHelpdesk()" :class="{'z-index-footer':$route.path == '/subscription'}">
                <div class="middle-helpdesk">
                    <div class="toolbar row no-gutters align-items-center px-4 px-sm-6 pb-4">
                        <div class="col">
                            <div class="row no-gutters align-items-center">
                                <div class="">
                                    <span class="text-footer">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/logos/help-desk.svg" class="help-desk-image">DigiHelp
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<div class="row no-gutters align-items-start justify-content-between flex-nowrap tag-line">
				<div class="d-flex align-items-center w-100 footer-flex-column">
					<!-- v-if="$route.path.startsWith('https://helpdesk.digicollect.com')" -->
					<div class="text-white fw-500 whiteSpace fs-12" style="position:relative;top:8px">App Version(P): V3.0.20</div>
					<!-- <div class="text-white fw-500 whiteSpace fs-12" v-else style="position:relative;top:8px">App Version(P): V3.0.3a37</div> -->
					<div class="contentCenter fw-500 pr-35 footer-mob-padding-fix">
						<span class="h6 text-footer-down">© Copyright 2014 - {{ new Date().getFullYear() }}
							<a class="footertext" href="https://www.digicollect.com/" target="_blank">DigiCollect</a> - All Rights Reserved
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
	data:function() {
        return {
            triggerZinde:false,
            triggerZindexes:false
        }
    },
	methods: {
		openHelpdesk() {
            if(location.origin.startsWith('https://testhelpdesk.digicollect.com') || location.origin.startsWith('http://localhost')){
                window.open('https://testadmin.digicollect.com/','_blank');
            }else if(location.origin.startsWith('https://helpdesk.digicollect.com')){
                window.open('https://admin.digicollect.com/','_blank');
            }
            this.show_hide_comp_switch_dropdown = false
            // this.$router.push('/settings?type=general');
        },
	}
}
</script>
<style scoped>
    .Line-7-Copy {
    	width: 2px;
    	height: 24px;
    	border: solid 1px #e0e3e6;
    }
    span.text-footer-down {
    	font-size: 12px;
    	text-align: center !important;
    	color: #ffffff !important;
		position: relative;
    	top: 8px;
    }
    .footertext {
    	color: #ffffff !important;
    	text-decoration: none !important;
    }
    .page-footer {
    	/* z-index: 9999; */
    	height: auto;
    }
    .no-gutters .textcenter-footer {
    	text-align: center;
    }
    .bg-secondary-light{
        /* background: #005dae; */
		background: #00448b;

    }
    .helpdesk-footer {
    	height: 38px;
    	border-radius: 15px;
    	background-color: #ffffff;
    	/* border: solid 2px #005dae; */
		border: solid 2px #00448b;
		margin: -35px auto 0;
		z-index: 0;
    }
    .text-footer {
    	font-size: 12px;
    	font-weight: 600;
    	font-style: normal;
    	font-stretch: normal;
    	line-height: 1.42;
    	letter-spacing: normal;
    	color: #4e5764;
    	display: flex;
    	align-items: center;
    	justify-content: center;
    }
    .help-desk-image {
    	width: 17.7px;
    	height: 17.7px;
    	-o-object-fit: contain;
    	object-fit: contain;
    	margin-left: 4px;
    	margin-right: 8px;
    }
    .middle-helpdesk {
    	padding-top: 9px;
    }
    .col-20,
    .col-sm-20,
    .col-md-20,
    .col-lg-20,
    .col-xl-20 {
    	position: relative;
    	width: 100%;
    	min-height: 1px;
    	padding-right: 15px;
    	padding-left: 15px;
    }
    .col-20 {
    	-webkit-box-flex: 0;
    	-webkit-flex: 0 0 20%;
    	-ms-flex: 0 0 20%;
    	flex: 0 0 20%;
    	max-width: 20%;
    }
	.footer-flex-column {
		flex-direction: column;
	}
	.footer-icon-placement{
		position: relative;
		bottom: 20px;
	}
	@media (max-width: 580px) {
		.footer-mob-padding-fix {
			padding-right: 0 !important;
		}
		.footer-icon-placement{
			position: relative;
			bottom: 40px;
			justify-content: center !important;
		}
    }
	@media (max-width: 388px) {
		.footer-icon-placement{
			bottom: 60px;
		}
    }
    @media (min-width: 576px) {
    	.col-sm-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
		.footer-flex-column {
			flex-direction: row;
		}
    }
    @media (min-width: 768px) {
    	.col-md-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
    }
    @media (min-width: 992px) {
    	.col-lg-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
    }
    @media (min-width: 1200px) {
    	.col-xl-20 {
    		-webkit-box-flex: 0;
    		-webkit-flex: 0 0 20%;
    		-ms-flex: 0 0 20%;
    		flex: 0 0 20%;
    		max-width: 20%;
    	}
    }
	.footer-icons{
		position:relative;
		bottom:37px;
		cursor: pointer;
	}
	.footer-icons img{
		width: 36px;
	}
	.tag-line{
		position: relative;
	}
	.z-index-footer{
		z-index: 1;
	}
</style>


